import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { CheckCircle2 } from 'lucide-react';
export function CountdownPricing() {
  return <section id="pricing" className="py-20 relative bg-brand-cream" data-id="element-52">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-53">
        <FadeIn className="text-center mb-12" data-id="element-54">
          <h2 className="text-4xl font-bold mb-4" data-id="element-55">💰 ELEGÍ TU OPCIÓN</h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-56">
          {/* Tier 1 */}
          <FadeIn delay={0.1} data-id="element-57">
            <div className="bg-brand-card border border-brand-border rounded-3xl p-8 h-full flex flex-col shadow-sm" data-id="element-58">
              <div className="mb-6" data-id="element-59">
                <h3 className="text-2xl font-bold text-brand-dark mb-2" data-id="element-60">
                  📘 MEGAPACK
                </h3>
                <p className="text-brand-accent font-medium mb-4" data-id="element-61">
                  HINCHADA, CANSADA Y NERVIOSA
                </p>
                <p className="text-brand-muted text-sm mb-4" data-id="element-62">
                  3 Tomos + 3 Checklists · Acceso inmediato
                </p>

                <div className="space-y-2 mb-6" data-id="element-63">
                  <div className="flex items-start gap-2 text-sm" data-id="element-64">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent shrink-0 mt-0.5" data-id="element-65" />
                    <span data-id="element-66">📘 Tomo 1: Adiós a la Hinchazón (20 pág)</span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-67">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent shrink-0 mt-0.5" data-id="element-68" />
                    <span data-id="element-69">📗 Tomo 2: Paz en Dos Minutos (20 pág)</span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-70">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent shrink-0 mt-0.5" data-id="element-71" />
                    <span data-id="element-72">📙 Tomo 3: Energía Real (20 pág)</span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-73">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent shrink-0 mt-0.5" data-id="element-74" />
                    <span data-id="element-75">✅ Checklist de 72hs (imprimible)</span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-76">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent shrink-0 mt-0.5" data-id="element-77" />
                    <span data-id="element-78">✅ Rastreador de síntomas semanal</span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-79">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent shrink-0 mt-0.5" data-id="element-80" />
                    <span data-id="element-81">✅ Guía de sustituciones rápidas</span>
                  </div>
                </div>
              </div>

              <div className="mb-8 bg-brand-cream border border-brand-accent/40 rounded-xl p-4" data-id="element-82">
                <div className="text-[#AAAAAA] line-through text-lg mb-1" data-id="element-83">
                  $33.000
                </div>
                <div className="text-4xl font-bold text-brand-accent flex items-baseline gap-1" data-id="element-84">
                  $19.990{' '}
                  <span className="text-lg text-brand-muted font-normal" data-id="element-85">
                    ARS
                  </span>
                </div>
              </div>

              <div className="mt-auto" data-id="element-86">
                <Button href="https://librofy.store/checkouts/cn/hWNC51uwTWyvvUJa27bz0HWD/es-ar?_r=AQAB_TUa4ABFDDi96MP0xnE83boXX2ki0L64Vo_e1O6QSY4&preview_theme_id=160306823389" fullWidth variant="outline" className="mb-4" data-id="element-87">
                  → QUIERO MI MEGAPACK
                </Button>
              </div>
            </div>
          </FadeIn>

          {/* Tier 2 */}
          <FadeIn delay={0.2} data-id="element-88">
            <div className="bg-brand-card border-2 border-brand-accent rounded-3xl p-8 h-full flex flex-col relative transform md:-translate-y-4 shadow-lg" data-id="element-89">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-terracotta text-white font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider" data-id="element-90">
                Más Elegida ⭐
              </div>

              <div className="mb-6" data-id="element-91">
                <h3 className="text-2xl font-bold text-brand-dark mb-2" data-id="element-92">
                  🏆 MEGAPACK PREMIUM
                </h3>
                <p className="text-brand-terracotta font-medium mb-4" data-id="element-93">
                  HINCHADA, CANSADA Y NERVIOSA
                </p>
                <p className="text-brand-muted text-sm mb-4" data-id="element-94">
                  3 Tomos + 3 Checklists + Kit Completo de Acción
                </p>

                <div className="space-y-2 mb-6" data-id="element-95">
                  <p className="font-bold text-brand-dark text-sm mb-2" data-id="element-96">
                    ✅ Todo lo del Megapack, más...
                  </p>
                  <div className="flex items-start gap-2 text-sm" data-id="element-97">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent shrink-0 mt-0.5" data-id="element-98" />
                    <span data-id="element-99">📘 Tomo 1: Adiós a la Hinchazón (20 pág)</span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-100">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent shrink-0 mt-0.5" data-id="element-101" />
                    <span data-id="element-102">📗 Tomo 2: Paz en Dos Minutos (20 pág)</span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-103">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent shrink-0 mt-0.5" data-id="element-104" />
                    <span data-id="element-105">📙 Tomo 3: Energía Real (20 pág)</span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-106">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent shrink-0 mt-0.5" data-id="element-107" />
                    <span data-id="element-108">✅ Checklist de 72hs (imprimible)</span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-109">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent shrink-0 mt-0.5" data-id="element-110" />
                    <span data-id="element-111">✅ Rastreador de síntomas semanal</span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-112">
                    <CheckCircle2 className="w-4 h-4 text-brand-accent shrink-0 mt-0.5" data-id="element-113" />
                    <span data-id="element-114">✅ Guía de sustituciones rápidas</span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-115">
                    <CheckCircle2 className="w-4 h-4 text-brand-terracotta shrink-0 mt-0.5" data-id="element-116" />
                    <span className="font-medium" data-id="element-117">
                      🎁 BONO 1: Lista de compras SOS (menos de $3.000 ARS)
                    </span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-118">
                    <CheckCircle2 className="w-4 h-4 text-brand-terracotta shrink-0 mt-0.5" data-id="element-119" />
                    <span className="font-medium" data-id="element-120">
                      🎁 BONO 2: Guía de suplementación con precios ARS
                      actualizados
                    </span>
                  </div>
                  <div className="flex items-start gap-2 text-sm" data-id="element-121">
                    <CheckCircle2 className="w-4 h-4 text-brand-terracotta shrink-0 mt-0.5" data-id="element-122" />
                    <span className="font-medium" data-id="element-123">
                      🎁 BONO 3: Plan de 21 días integrado (los 3 sistemas
                      juntos)
                    </span>
                  </div>
                </div>
              </div>

              <div className="mb-8 bg-brand-cream border border-brand-accent rounded-xl p-4" data-id="element-124">
                <div className="text-[#AAAAAA] line-through text-lg mb-1" data-id="element-125">
                  $51.000
                </div>
                <div className="text-5xl font-bold text-brand-accent flex items-baseline gap-1" data-id="element-126">
                  $27.990{' '}
                  <span className="text-lg text-brand-muted font-normal" data-id="element-127">
                    ARS
                  </span>
                </div>
              </div>

              <div className="mt-auto" data-id="element-128">
                <Button href="https://librofy.store/products/megapack-hinchada-cansada-nerviosa-premium" fullWidth size="xl" variant="terracotta" className="mb-4" data-id="element-129">
                  → QUIERO EL MEGAPACK PREMIUM ⭐
                </Button>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}